import React, { useEffect, useState } from 'react';
import { RoleType } from '@/constants';
import { useCourseModel } from '../models';
import { useMenu } from './index.ViewHooks';
import { ContentMenu } from '../../components';
import { TAB_TOP_ID } from '../../constants';

interface MenuProps {
  type: RoleType;
}

export const Menu = React.memo(({ type }: MenuProps) => {
  const { menu } = useCourseModel(({ menu }) => [menu[type]]);
  const { contentId, defaultOpenKeys, handleClick, contents } = useMenu({
    menu,
    type,
  });
  const [defaultLink, setDefaultLink] = useState<HTMLElement>();

  useEffect(() => {
    if (defaultOpenKeys.length) {
      const openLink: HTMLElement = document.getElementsByClassName(
        `course-id-${defaultOpenKeys[0]}`,
      )[0] as HTMLElement;
      setDefaultLink(openLink);
    }
  }, [contentId, defaultOpenKeys]);

  useEffect(() => {
    if (defaultLink) {
      const defaultLinkAnchor = defaultLink.querySelector('a');
      defaultLinkAnchor?.click();
    }
  }, [defaultLink]);
  return (
    <ContentMenu
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={[contentId]}
      contents={contents}
      onClickMenuItem={handleClick}
      anchor={TAB_TOP_ID}
      menuPage="seller_university_homepage"
      menuModule="seller_university_homepage_course"
    />
  );
});
